// libs
import { HTMLMotionProps, motion } from "framer-motion";
import styled from "styled-components";
// components
import Icon from "./Icon";
// other
import { IconKey } from "../models/client";
import { Color } from "../models/theme";

interface FabButtonProps extends HTMLMotionProps<"button"> {
  icon: IconKey;
  color?: Color | "transparent";
}

const StyledButton = styled(motion.button)<{ color: Color | "transparent" }>`
  height: 48px;
  width: 48px;
  background-color: ${({ theme, color }) =>
    color === "transparent" ? color : theme.colors[color]};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  border: none;
  cursor: pointer;

  svg {
    width: 32px;
    height: 32px;
  }
`;

function FabButton({ icon, color = "hotPink", ...rest }: FabButtonProps) {
  return (
    <StyledButton
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 1 }}
      color={color}
      {...rest}
    >
      <Icon icon={icon} />
    </StyledButton>
  );
}

export default FabButton;
